<template>
    <div class="warpper">
        <div class="flex align-center justify-between">
            <div class="page-title">会员续费</div>
            <div class="page-back" @click="toBack">返回</div>
        </div>
        <div class="page-info">
            <div class="basic-info active">
                <el-form label-width="100px">
                    <el-form-item label="机构名称">
                        <el-input v-model="detail.morgname" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话">
                        <el-input v-model="detail.user_phone" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="会员身份">
                        <el-input v-model="detail.user_rank_name" disabled></el-input>
                    </el-form-item>
<!--                    <el-row>-->
<!--                        <el-col :span="12">-->
<!--                            <el-form-item label="入会时间">-->
<!--                                <el-input v-model="detail.user_reg_time" disabled></el-input>-->
<!--                            </el-form-item>-->
<!--                        </el-col>-->
<!--                        <el-col :span="12">-->
                            <el-form-item label="到期时间">
                                <el-input v-model="detail.user_end_time" disabled></el-input>
                            </el-form-item>
<!--                        </el-col>-->
<!--                    </el-row>-->

                    <el-form-item label="续费年限" v-if="!isSjkxxh">
                        <el-select v-model="year" placeholder="请选择">
                            <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <div class="pay-money">
                        缴费金额：<span>{{parseFloat(Number(year) * Number(money)).toFixed(2)}}元</span></div>
                    <div><span class="text-red">银行转账时请务必备注会员姓名及手机号，社团管理规定个人会员发票抬头为会员姓名，不能为单位。</span></div>
                    <el-form-item label="支付方式">
                        <el-radio-group v-model="pay_type">
                            <el-radio :label="0" v-if="!!wechatConfigState">微信支付</el-radio>
                            <el-radio :label="1">公账支付</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="pay_type === 1">
                       <div class="transfer-info flex flex-direction">
                           <div><span>开户行：</span>{{transfer_info.kaihuhang}}</div>
                           <div><span>收款单位：</span>{{transfer_info.shoukuandanwei}}</div>
                           <div><span>银行卡号：</span>{{transfer_info.kahao}}</div>
                       </div>
                    </el-form-item>

                </el-form>
            </div>
            <div class="basic-info">
                <el-form label-width="130px">
                    <el-form-item label="是否需要发票">
                        <el-radio-group v-model="invoice_type">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="会员姓名">
                        <el-input v-model="invoice_name"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱">
                        <el-input v-model="invoice_email"></el-input>
                    </el-form-item>
                </el-form>
                <el-image v-if="fapiao_img" :src="IMAGE_PATH + fapiao_img" class="width-100" :preview-src-list="[IMAGE_PATH + fapiao_img]"></el-image>
                <el-button class="input-form-btn" @click="submitPay">立即续费</el-button>
            </div>
            <div class="tips">续费问题服务电话:{{orginze.kefu_tel}}</div>
        </div>
        <div v-show="qrcodeUrl" class="qrcode">
            <qrcode class="margin-top-xl"
                    :text="qrcodeUrl"
                    v-if="qrcodeUrl"
                    :size="250">
            </qrcode>
            <p class="tips">请使用微信扫码支付</p>
            <el-button type="info" icon="el-icon-close" circle @click="qrcodeUrl = ''"></el-button>
        </div>
        <result-message-dialog :applyDialogVisible="dialogSuccessVisible" :title="msg_title"
                               :tips="msg_tip" :iconfont="'el-icon-success'" :iconVisible="true" @watchState="watchState"></result-message-dialog>
        <payment-transfer-dialog :applyDialogVisible="dialogTransferVisible" @fileSuccess="fileSuccess"
                                 @cancelDialog="cancelDialog"></payment-transfer-dialog>
    </div>
</template>

<script>
    import Qrcode from 'vue-qr'
    import {getOrderInfo,getOrganizInfo, wxPay, checkPayState,transferPay,getDuiGongData} from "@/api/member";
    import ResultMessageDialog from "@/components/ResultMessageDialog.vue";
    import PaymentTransferDialog from "@/components/PaymentTransferDialog.vue";
    import {IMAGE_PATH} from "@/config";
    import {isSjkxxh} from "@/utils/utils";

    export default {
        name: "payment",
        components: {
            PaymentTransferDialog,
            ResultMessageDialog,
            qrcode: Qrcode
        },
        data() {
            return {
                IMAGE_PATH:IMAGE_PATH,
                options: [{
                    value: 1,
                    label: '1年'
                }, {
                    value: 2,
                    label: '2年'
                }, {
                    value: 3,
                    label: '3年'
                }, {
                    value: 4,
                    label: '4年'
                }, {
                    value: 5,
                    label: '5年'
                }, {
                    value: 6,
                    label: '6年'
                }],
                year: 1,
                money: '0.00',
                pay_type: 0,
                invoice_type: 1,
                qrcodeUrl: '',
                invoice_name: '',
                invoice_identifier: '',
                invoice_email: '',
                fapiao_img: '',
                detail: '',
                orginze: '',
               wechatConfigState:0,

                msg_title: '',
                msg_tip: '',
                dialogSuccessVisible: false,
                timer: '',
                order_no: '',
                dialogTransferVisible: false,
                transfer_info:''
            }
        },
        computed: {
            isSjkxxh() {
                return isSjkxxh(this.orginze.org_id)
            }
        },
        created() {
            this.$emit('setIndex', [0], '会员续费')
            this.init()
        },
        destroyed() {
            clearInterval(this.timer);
        },
        methods: {
            async init() {
                let _data = await getOrderInfo()
                if (_data.status === 200) {
                    this.invoice_name = _data.data.invoice_name
                    this.invoice_identifier = _data.data.invoice_identifier
                    this.invoice_email = _data.data.email
                    this.money = _data.data.rank2price
                    this.wechatConfigState = _data.data.wechatConfigState
                    this.detail = _data.data
                  if(!this.wechatConfigState){
                    this.pay_type = 1
                  }
                }
                _data = await getOrganizInfo()
                if (_data.status === 200) {
                    this.orginze = _data.data
                }
                _data = await getDuiGongData(this.$store.state.user.mid)
                if (_data.status === 200) {
                    this.fapiao_img = _data.data.fapiao_img
                    this.transfer_info = _data.data
                }


            },
            submitPay() {
                //需要发票
                if (this.invoice_type === 1) {
                    if (!this.invoice_name) return this.$message.error('请输入会员姓名')
                    if (!this.invoice_email) return this.$message.error('请输入邮箱')
                }
                this.wxPay()
            },
            async wxPay() {
                let _data = await wxPay(this.year, Number(this.pay_type) + 1, this.invoice_type, this.invoice_name, this.invoice_identifier,this.invoice_email)
                if (_data.status === 200) {
                    this.order_no = _data.data.order_number
                    if (this.pay_type === 0){
                        this.qrcodeUrl = _data.data.url
                        let _this = this
                        this.timer = setInterval(function () {
                            //执行内容
                            _this.checkPayState()
                        }, 3000);
                    }else {
                        this.dialogTransferVisible = true
                    }
                }
            },
            async checkPayState() {
                let _data = await checkPayState(this.order_no)
                if (_data.status === 200) {
                    this.qrcodeUrl = ''
                    this.order_no = ''
                    clearInterval(this.timer);
                    this.msg_title = '微信支付'
                    this.msg_tip = '支付成功'
                    this.dialogSuccessVisible = true
                }
            },
            watchState(state) {
                this.dialogSuccessVisible = false;
                if (state) this.toBack()
            },
            //  上传文件
            async fileSuccess(val) {
                let _data = await transferPay(this.order_no,val.file_path)
                if (_data.status === 200) {
                    this.order_no = ''
                    this.msg_title = '续费提交成功'
                    this.msg_tip = '提交成功，我们会在24小时内进行审核通过后续费成功'
                    this.dialogSuccessVisible = true
                    this.dialogTransferVisible = false
                }
            },
            cancelDialog() {
                clearInterval(this.timer);
                this.dialogTransferVisible = false
            },
            toBack() {
                this.$router.go(-1)
            }
        }

    }
</script>

<style scoped lang="scss">
    .warpper {
        padding: 20px 30px;
        background-color: #ffffff;
        border-radius: 10px;
        .page-info {
            display: flex;
            flex-direction: column;
            width: 719px;
            margin: 58px auto 0;
            .tips {
                font-size: 26px;
                font-weight: bold;
                text-align: center;
                margin: 30px;
            }
            .basic-info {
                display: flex;
                flex-direction: column;
                background-color: #ffffff;
                border-radius: 10px;
                padding: 40px 63px 20px 0px;
                &.active {
                    border: solid 1px #e4e4e4;
                    padding: 40px 63px 20px 30px;
                }
                .pay-money {
                    font-size: 16px;
                    color: #999999;
                    text-align: center;
                    margin: 20px 0;
                    span {
                        font-size: 24px;
                        color: #ed4444;
                    }
                }
                .el-select {
                    width: 100%;
                }
                .input-form-btn {
                    width: 200px;
                    height: 40px;
                    background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                    linear-gradient(#0a2240, #0a2240);
                    background-blend-mode: normal, normal;
                    border-radius: 20px;
                    font-size: 16px;
                    color: #ffffff;
                    margin: 0 auto;
                }
            }

        }
        .transfer-info{
            border: solid 1px #e4e4e4;
            padding: 30px;
            font-size: 16px;
            span {
                color: #999999;
            }
        }
        .qrcode {
            position: fixed;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: #00000099;
            text-align: center;
            z-index: 99;

            .tips {
                font-size: 16px;
                color: white;
                margin: 30px;
            }
        }
    }
</style>